Common.login = () => {
	const modal = $('.login-v1-modal');
	$('a[href="#login"]').click(e => {
		e.preventDefault();

		modal.modal();

		return false;
	})
}
